
import { COUNTRIES } from "../../utils/HomepageData";
import ABOUT_DATA from "../../utils/aboutData";
import { useParams } from "react-router-dom";
import Button from "../../components/Button";
import Select from "../../components/Select";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setCountryFrom,
  setCountryTo,
  setAmount,
} from "../../store/slices/formSlice";

const FormTransferHotspot = () => {
  const {id} = useParams();
  let toCountry;
  console.log(id);
  for (let key in COUNTRIES) {
    if (COUNTRIES[key].name.toLowerCase() === id) {
      toCountry = COUNTRIES[key];
      break;
    }
  }
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form);

  const onSubmit = () => {
    let { amount, amountType, countryFrom, countryTo} = formData;
    countryTo = toCountry;
    const currencyFromParams = countryFrom?.currencies?.[0]?.code || "";
    const currencyToParams = toCountry?.currencies?.[0]?.code || "";

    if (
      countryFrom &&
      countryTo &&
      amount &&
      amountType &&
      currencyFromParams &&
      currencyToParams
    ) {
      navigate(
        `/search/send-money-${countryFrom.code.toLowerCase()}-to-${toCountry.code.toLowerCase()}`
      );
    } else {
      alert("All fields are mandatory");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "amount") dispatch(setAmount(value));
  };

  const handleCountryChange = (country, name) => {
    if (name === "countryFrom") dispatch(setCountryFrom(country));
    if (name === "countryTo") dispatch(setCountryTo(country));
  };

   return (
    <div className="mx:[20px] sm:mx-[50px] mt-[100px] sm:mt-[140px]">
      <h2 className="font-[700] text-[#111B31] text-2xl md:text-[36px] md:mt-[60px] md:mb-[20px] px-[20px] sm:px-0">
        {ABOUT_DATA.best_transfer_rates.heading}
      </h2>
      <div className="sm:flex bg-white shadow-lg m-[20px] sm:m-0">
        <div className="sm:flex gap-20 w-full py-[20px] sm:py-[50px] px-[30px]">
          {/* <div className="sm:flex justify-between gap-32"> */}
          {/* Country From Selector */}
          <Select
            isCountrySelector
            label="Money Sent from"
            name="countryFrom"
            defaultValue={formData.countryFrom?.code}
            onChange={(country) => handleCountryChange(country, "countryFrom")}
            containerClass="w-full"
            classes="lg:w-full"
          />

          {/* Country To Selector */}
          <Select
            isCountrySelector
            label="Money Sent to"
            name="countryTo"
            defaultValue={toCountry.code}
            onChange={(country) => handleCountryChange(country, "countryTo")}
            containerClass="w-full mt-[20px] sm:mt-0"
            classes="lg:w-full"
            isDisabled={true}
          />

          {/* Amount Input */}
          <div className="mt-[20px] sm:mt-0">
            <h2 className="text-[#2C2C2C] font-[700]">Amount</h2>
            <div className="flex items-center mt-[5px] border border-[#7B3BCC] py-3 px-4 rounded-lg text-[#2C2C2C] font-[600]">
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={formData.amount || ""}
                name="amount"
                className="w-[80px] h-[35px] outline-none bg-transparent"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,7}$/.test(value)) {
                    handleChange(e);
                  }
                }}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-end mt-[20px] sm:mt-0">
            <Button
              btnText="Find Best Transfer Rates"
              onClick={onSubmit}
              classes="bg-[#7B3BCC] w-full max-w-[210px] py-3 text-sm text-white font-bold py-2 sm:text-base md:w-[100px] md:mx-auto lg:w-[300px] lg:text-lg xl:text-[16px] transition-colors hover:bg-[#6a30b5] duration-300 rounded-lg hover:scale-105"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormTransferHotspot;